module.exports = __webpack_public_path__ + "img/successLight.792e2fe3.png";